import type { ConversationNodeTags } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeTags;
};

export function RoutedThroughTags({ node }: Props): JSX.Element {
  return (
    <>
      Tags · Tagged with <strong>{node.tag_ids.join(', ')}</strong>
    </>
  );
}
